import React from "react";
import {FormFeedback, Input, Label} from "reactstrap";
import {getShopInfosInStorage} from "tunnel-commande/src/components/cart/ShopInfos";
import {withTranslation} from "react-i18next";


class DimensionInput extends React.Component<any, any> {

  private readonly dimensions: any = null;
  private readonly minCm: any = null;
  private readonly maxCm: any = null;

  constructor(props: any) {
    super(props);
    this.state = {
      dimensions: {l: this.props.dimension.l, h: this.props.dimension.h},
      disabled: this.props.disabled,
      validL: {global: this.props.dimension.l == 0 ? true : false, min: false , max: false, maxOther: false,  minOther: false },
      validH: {global: this.props.dimension.h == 0 ? true : false, min: false , max: false, maxOther: false,  minOther: false }
    }

    this.dimensions = getShopInfosInStorage() ?  getShopInfosInStorage().dimensionsVisuel : {};
    this.minCm = this.dimensions && this.dimensions.centimetreMinLargeur < this.dimensions.centimetreMinHauteur ? this.dimensions.centimetreMinLargeur : this.dimensions && this.dimensions.centimetreMinHauteur ? this.dimensions.centimetreMinHauteur : 0;
    this.maxCm = this.dimensions && this.dimensions.centimetreMaxLargeur > this.dimensions.centimetreMaxHauteur ? this.dimensions.centimetreMaxLargeur : this.dimensions && this.dimensions.centimetreMaxHauteur ? this.dimensions.centimetreMaxHauteur : 0;
    this.handleOnFormChange = this.handleOnFormChange.bind(this);
    this.handleOnDimensionChange = this.handleOnDimensionChange.bind(this);
  }

  private handleOnDimensionChange(e: any) {
    if(this.props.onChange) {
      this.props.onChange({...this.props.dimension, [e.target.name]: e.target.value});
    }
  }

  private handleOnFormChange(e: any) {
    if(this.props.onChange) {
      this.props.onChange(e);
    }
  }

  private handleOnValide(value: number, largeur: boolean = true){
    let values = this.checkValide(value, largeur);
    const valuesInOTherSize = this.checkValide(value, !largeur);
    const otherValue = largeur ? this.state.dimensions.h : this.state.dimensions.l;

    const othersValues = this.checkValide(otherValue, !largeur);
    if(!values.max && othersValues.maxOther && valuesInOTherSize.valide) {
      values = valuesInOTherSize;
    } else if(!values.min && value >= this.minCm) {
      const surfaceTotaleDemandee = this.dimensions.centimetreMinLargeur * this.dimensions.centimetreMinHauteur;
      const currentSurfaceTotale = this.state.dimensions.h * this.state.dimensions.l;
      if(currentSurfaceTotale >= surfaceTotaleDemandee || (this.state.dimensions.h === 0 || this.state.dimensions.l === 0 )) {
        values = {...values,valide: true, min: true};
      }
    }

    const surfaceTotaleMax = this.dimensions.centimetreMaxLargeur * this.dimensions.centimetreMaxHauteur;
    const currentSurfaceTotale = this.state.dimensions.h * this.state.dimensions.l;
    if(currentSurfaceTotale > surfaceTotaleMax ) {
        values = {...values,valide: false, min: true, max: false};
    }
    this.setStateValide(largeur, values);
  }

  private checkValide(value: number, largeur: boolean = true){
    const isValidMin = (largeur ? value >= this.dimensions.centimetreMinLargeur : value >= this.dimensions.centimetreMinHauteur);
    const isValidMax = (largeur ? value <= this.dimensions.centimetreMaxLargeur : value <= this.dimensions.centimetreMaxHauteur);
    const isValidMaxIfOther =  this.dimensions.centimetreMaxLargeur < this.dimensions.centimetreMaxHauteur ?  this.dimensions.centimetreMaxLargeur : this.dimensions.centimetreMaxHauteur;
    const isValidMinIfOther = this.dimensions.centimetreMinLargeur < this.dimensions.centimetreMinHauteur ?  this.dimensions.centimetreMinLargeur : this.dimensions.centimetreMinHauteur;

    return {
      valide: isValidMin && isValidMax,
      min: isValidMin,
      max: isValidMax,
      maxOther: isValidMaxIfOther,
      minOther: isValidMinIfOther,
    };
  }

  private setStateValide(largeur: boolean = true, values: any) {
    if(largeur) {
      this.setState({
        validL: {
          global: values.valide,
          min: values.min,
          max: values.max,
          maxOther: values.maxOther,
          minOther: values.minOther,
        }
      })
    } else if(!largeur) {
      this.setState({
        validH: {
          global: values.valide,
          min: values.min,
          max: values.max,
          maxOther: values.maxOther,
          minOther: values.minOther,
        }
      })
    }
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
    if(prevProps.dimension !== this.props.dimension) {
      this.setState({  dimensions: {l: this.props.dimension.l, h: this.props.dimension.h}}, () => {
        if(this.state.dimensions.l != 0) {
          this.handleOnValide(this.state.dimensions.l);
        } if(this.state.dimensions.h != 0) {
          this.handleOnValide(this.state.dimensions.h, false);
        }
      });

    }
  }

  render() {
    return (
      <div className={'d-flex position-relative'}>
        <div>
          <Label className={'grey white-space-nowrap'}><span className={'d-inline d-md-none'}>(L)</span><span className={'d-none d-md-inline'}>{this.props.t('width')}</span> {this.props.t('in_cm')} :</Label>
          <Input  bsSize={"lg"} className={'border-dark input-dt-cmd '} placeholder={'0'} min={this.minCm} max={this.maxCm} invalid={!this.state.validL.global} valid={this.state.validL.global}  name={"l"} type={"number"} step={"1"}  disabled={this.state.disabled} value={this.state.dimensions.l}  onChange={this.handleOnDimensionChange} />
          <FormFeedback className={'mt-1 m0 position-absolute FormFeedbackDimensionInput'}>
            {!this.state.validL.global &&
            <ul className={'list-unstyled'}>
              {!this.state.validL.min &&
              <li className={'red mr-2'}>{this.props.t('required_dimensions_min').replace('CMinL', this.dimensions.centimetreMinLargeur)} x {this.dimensions.centimetreMinHauteur}cm</li>
              }
              {!this.state.validL.max &&
                  <li className={'red mr-2'}>{this.props.t('required_dimensions_max').replace('CMaxL', this.dimensions.centimetreMaxLargeur)} x {this.dimensions.centimetreMaxHauteur}cm</li>
              }
            </ul>
            }
          </FormFeedback>
        </div>
        <div className={'font36 align-self-center px-4 d-flex flex-column'}>
          <Label className={''}>&nbsp;</Label>
          X
        </div>
        <div>
          <Label className={'grey white-space-nowrap'}><span className={'d-inline d-md-none'}>(H)</span><span className={'d-none d-md-inline'}>{this.props.t('height')}</span> {this.props.t('in_cm')} :</Label>
          <Input  bsSize={"lg"} className={'border-dark input-dt-cmd '} placeholder={'0'}  min={this.minCm} max={this.maxCm} invalid={!this.state.validH.global}  valid={this.state.validH.global}   name={"h"} type={"number"} step={"1"} disabled={this.state.disabled} value={ this.state.dimensions.h} onChange={this.handleOnDimensionChange} />
          <FormFeedback className={'mt-1 m0 position-absolute FormFeedbackDimensionInput'}>
            {!this.state.validH.global && this.state.validL.global &&
            <ul className={'list-unstyled'}>
              {!this.state.validH.min &&
              <li className={'red mr-2'}>{this.props.t('required_dimensions_min').replace('CMinL', this.dimensions.centimetreMinLargeur)} x {this.dimensions.centimetreMinHauteur}cm</li>
              }
              {!this.state.validH.max &&
              <li className={'red mr-2'}>{this.props.t('required_dimensions_max').replace('CMaxL', this.dimensions.centimetreMaxLargeur)} x {this.dimensions.centimetreMaxHauteur}cm</li>
              }
            </ul>
            }
          </FormFeedback>
        </div>
      </div>
    );
  }
}
export default withTranslation('common')(DimensionInput);
